import { Component } from '@angular/core';
import { PolicyHeaderComponent } from '../policy-header/policy-header.component';

@Component({
  selector: 'app-aul-035-24',
  standalone: true,
  imports: [PolicyHeaderComponent],
  templateUrl: './aul-035-24.component.html',
  styleUrl: './aul-035-24.component.scss'
})
export class Aul03524Component {

}
